module.exports = __webpack_public_path__ + "a65d18b7aaa2fd66772540bbbec1b52a.png";